import {
  useTwoStepAuthCode,
  CodeModalResult,
} from "@/features/two-step-authentication/hooks/use-two-step-authentication-code";
import { BaseRoundButton } from "@/shared/components/button/base-round-button";
//import { SimpleForm } from "@/shared/components/text-box/simple-form";
import { BasePageModal } from "@/shared/components/modal/page-modal/base-page-modal";
import React from "react";
import { useTwoStepAuthCodeStates } from "@/features/two-step-authentication/hooks/use-two-step-authentication-code-states";
import { useModalContext } from "@/shared/components/modal/contexts/modal-context";
import { SegmentedForm } from "@/shared/components/text-box/segmented-form";
import { useLoginContext } from "@/features/auth/contexts/login-context";

interface CodeProps {
  onCloseModal: () => void;
  onCompleteModal: (result: CodeModalResult) => void;
}

// 2段階認証コード入力モーダル
export const TwoStepReleaseCodeModal = ({ onCloseModal, onCompleteModal }: CodeProps) => {
  const {
    setOpenNotLoginModal,
  } = useModalContext();
  const {
    setTwoStepReleaseCode,
  } = useLoginContext();
  const {
    verifyReleaseCode,
  } = useTwoStepAuthCode({ onCompleteModal });
  const {
    isActiveReleaseCodeVerifyButton,
    setIsActiveReleaseCodeVerifyButton,
  } = useTwoStepAuthCodeStates();

  return (
    <BasePageModal
      title="2段階認証の設定"
      handleClose={onCloseModal}
      className="md-login-code"
      disableOverlayClose={true}
      bottomChildren={
        <>
          <BaseRoundButton
            id="btnSubmit"
            className="btn-cancel"
            buttonText="キャンセル"
            onClick={() => {
              setOpenNotLoginModal("TwoStepAuthCode");
            }}
          />
          <BaseRoundButton
            id="btnSubmit"
            buttonText="解除コードを送信"
            onClick={verifyReleaseCode}
            isActive={isActiveReleaseCodeVerifyButton}
          />
        </>
      }
    >
      <h2>
        2段階認証を無効化します
      </h2>
      <dl>
        <dt>解除コード</dt>
        <dd className="input_code">
          <SegmentedForm
            onChange={(value, isComplete) => {
              setTwoStepReleaseCode(value);
              setIsActiveReleaseCodeVerifyButton(isComplete)
              }}
              id={"code"}
              length={8}
            />
        </dd>
      </dl>
      <div className="message">
        <p>2段階認証を有効にした際に届いている「2段階認証設定完了のご連絡」メールをご確認いただき、メール内に記載の解除コードを入力してください。</p>
      </div>
    </BasePageModal>
  );
};
